import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'convertToDate'
})
export class ConvertToDatePipe implements PipeTransform {
  transform(value: number): Date {
    let parsedDate = moment(value);
    if (!parsedDate.isValid()) {
        parsedDate = moment();
    }
    return parsedDate.toDate();
  }
}